import { createFileRoute } from '@tanstack/react-router';
import { PersonalDataLayout } from '@/features/account/profile/personal-data/shared';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/perfil/dados-pessoais')({
  component: PersonalDataLayout,
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
